import React from 'react';
import { Field, useFormikContext } from 'formik';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import ImageUpload, {
  UploadAspectRatios
} from 'legacy/common/components/wysiwyg-form/ImageUpload';
import { useImageUploadCommand } from 'legacy/common/hooks/useImageUploadCommand';
import Error from 'legacy/common/components/wysiwyg-form/Error';

import { useOrganization } from '../../../../context/EditOrganizationProvider';
import { EditOrganizationFormValues } from '../../../../types/edit-organization';

const BadgeAndName = ({ uploadImage }) => {
  const { t } = useTranslation(['organizations']);
  const { values, touched, errors } =
    useFormikContext<EditOrganizationFormValues>();
  const uploadImageCommand = useImageUploadCommand();
  const { data } = useOrganization();

  return (
    <>
      <ImageUpload
        photoUrl={values.badgeImage}
        className="mx-auto w-[88px]"
        isUploading={uploadImageCommand.isLoading}
        aspectRatio={UploadAspectRatios.OneToOne}
        label={t('form.badgeImageLabel')}
        maxLabel={null}
        defaultIconSize={32}
        onUploadPhoto={uploadImage('badgeImage')}
        error={(touched.badgeImage && errors.badgeImage) || ''}
        disabled={data.isSubmitting}
      />
      <Field
        id="name"
        name="name"
        autoComplete="off"
        className={classNames(
          'w-full mt-4 p-1 text-3xl font-bold rounded-md text-center placeholder-neutral-800',
          errors.name && touched.name ? 'bg-red-100' : 'bg-transparent'
        )}
        disabled={data.isSubmitting}
        placeholder={t('form.nameLabel')}
      />
      {errors.name && touched.name && <Error error={errors.name} />}
    </>
  );
};

export default BadgeAndName;
